// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__3_jyI"};